<template>
  <!-- 购买商品详情页 -->
  <div class="contentss">
    <van-tabs
      color="#FC563A"
      @scroll="touchEvent"
      v-model="active"
      line-width="0.8rem"
      scrollspy
      sticky
    >
      <template #nav-left>
        <van-icon name="arrow-left" @click="toback" />
      </template>
      <van-tab title="商品">
        <div class="swiper">
          <div class="headerIcon">
            <img
              class="back"
              src="../../assets/img/icon/组1255@2x.png"
              alt=""
              @click="toback"
            />
          </div>
          <van-swipe @change="onChange">
            <van-swipe-item v-for="item in images" :key="item.id">
              <video
                v-if="item.type == 'video'"
                id="myVideo"
                class="video-js vjs-default-skin vjs-big-play-centered "
                style="width:100%;height:100%;object-fit: fill"
                :controls="true"
              >
                <source :src="item.imgUrl" type="video/mp4" />
              </video>
              <img v-if="item.type == 'image'" :src="item.imgUrl" />
            </van-swipe-item>
            <div class="custom-indicator" slot="indicator">
              {{ current + 1 }}/{{ this.images.length }}
            </div>
          </van-swipe>
        </div>
        <div class="productInfo">
          <h4>{{ productInfo.goods_name }}</h4>
          <span class="bewrite">{{ productInfo.goods_desc }}</span>
          <p class="money" v-if="this.status != 0">
            ¥{{ Number(productInfo.outer_goods_price).toFixed(2) }}
          </p>
          <p
            v-if="this.status == 0"
            style="color:#F74B2E;font-size:0.533333rem;font-weight:500"
          >
            暂不销售
          </p>
        </div>
        <div class="site">
          <ul>
            <li @click="showOne = true">
              <span class="text">选择</span>
              <van-cell-group class="siteTwo" :border="false">
                <span v-if="valueNum == '' || valueNum == null"
                  >请选择商品规格</span
                >
                <span v-else>已选：{{ radioName }}x{{ valueNum }}</span>
              </van-cell-group>
              <van-icon class="arrow" name="arrow" />
            </li>
            <li class="" @click="addressListShow = true">
              <span class="text">送至</span>
              <van-cell-group class="selectAddress" :border="false">
                <span v-if="this.AddressShow" class="">{{
                  this.fieldValue
                }}</span>
                <span v-else>请添加收货地址</span>
              </van-cell-group>
              <van-icon class="arrow" name="arrow" />
            </li>
            <li>
              <span class="text">服务</span>
              <div class="lastOptions">
                <div>
                  <img src="../../assets/img/icon/编组 2@2x.png" alt="" />
                  <span>支持7天无理由退款</span>
                </div>
                <div>
                  <img src="../../assets/img/icon/编组 2@2x.png" alt="" /><span
                    >3年质保</span
                  >
                </div>
                <div>
                  <img src="../../assets/img/icon/编组 2@2x.png" alt="" /><span
                    >全国包邮</span
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </van-tab>
      <van-tab title="评价">
        <div class="appraisal">
          <div class="appraisalHeader">
            <p>用户评价({{ commentLength }})</p>
            <div @click="$router.push('/evaluationDetails')">
              <span>全部评价</span> <van-icon size="0.4rem" name="arrow" />
            </div>
          </div>
        </div>
        <div v-if="Evaluation" class="appraisalList">
          <ul>
            <li v-for="item in commentList" :key="item.id">
              <div class="head">
                <img :src="item.user_head_img" alt="" />
                <div class="headTop">
                  <span class="name">{{ item.user_name }}</span>
                  <div class="headeValuate">
                    <p>{{ item.add_time }}</p>
                    <van-rate
                      size=" 0.346667rem"
                      color="#FC563A"
                      readonly
                      v-model="item.log_score"
                    />
                  </div>
                </div>
              </div>
              <p class="evaluateConent">{{ item.remark }}</p>
              <div class="cpnentImg">
                <img
                  v-for="itemImg in item.url_list"
                  :key="itemImg.id"
                  :src="itemImg.fileUrl"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </div>
        <div v-if="!Evaluation" class="noEvaluation">
          <p>暂无评价</p>
        </div>
      </van-tab>
      <van-tab class="bigImg" title="详细">
        <img :src="this.productInfo.productImg" alt="" />
      </van-tab>
    </van-tabs>
    <div class="shoppingOptions">
      <van-goods-action>
        <van-goods-action-icon @click="onClickIcon">
          <p>
            <img
              class="iconImg"
              src="../../assets/img/icon/组 9727@2x.png"
              alt=""
            />
          </p>
          <p>客服</p>
        </van-goods-action-icon>
        <van-goods-action-icon @click="toBuyCart">
          <van-badge :content="cartNum == 0 ? '' : cartNum">
            <div class="child" />
          </van-badge>
          <div>
            <img
              class="iconImg"
              src="../../assets/img/icon/组 9728@2x.png"
              alt=""
            />
          </div>
          <p>购物车</p>
        </van-goods-action-icon>
        <van-goods-action-button
          v-if="this.status != 0"
          :disabled="this.onsell"
          type="warning"
          text="加入购物车"
          @click="addShoppingCart"
        />
        <van-goods-action-button
          v-if="this.status != 0"
          :disabled="this.onsell"
          type="danger"
          text="立即购买"
          @click="onClickButton"
        />
        <div v-if="this.status">
          <div class="sold" v-if="this.status == 0">商品已下架</div>
        </div>
      </van-goods-action>
    </div>
    <div v-if="this.onsell_num">
      <div
      class="sell"
      v-if="this.onsell_num == 0 && this.status != 0 ? true : false"
    >
      该商品已售完，非常抱歉！
    </div>
    <div class="sell" v-if="this.status == 0 ? true : false">
      该商品已下架，非常抱歉！
    </div>
    </div>
    
    <van-image-preview v-model="ImagePreviewShow" :images="imagesLists">
    </van-image-preview>
    <!-- 下单 -->
    <van-action-sheet v-model="showOne">
      <van-icon class="ion" name="cross" @click="showOne = false" />
      <div class="contents">
        <div class="productInfo">
          <div class="imgge">
            <img :src="img" alt="" />
          </div>
          <div class="productTitle">
            <h4>{{ productInfo.goods_name }}</h4>
            <span class="money"
              >¥{{ price ? price : productInfo.outer_goods_price }}</span
            >
          </div>
        </div>
        <div class="specifications">
          <div>
            <span style="font-weight: 600;">颜色</span>
            <div class="btn">
              <van-button
                v-for="(item, index) in opmInfo"
                :key="index"
                :icon="item.color_img"
                size="small"
                :class="{ formats: isActive === item.id }"
                :disabled="item.stock <= 0 ? true : false"
                @click="getBack(item)"
              >
                {{ item.color_name }}
              </van-button>
            </div>
          </div>
          <div class="num">
            <span style="font-weight: 600;">数量</span>
            <van-stepper
              v-model="value"
              min="1"
              :max="totalQuantity < 99 ? totalQuantity : '99'"
              theme="round"
              button-size="22"
              disable-input
            />
          </div>
        </div>
        <div class="btnBox">
          <van-button round @click="selectInfos" type="info">确定</van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="show">
      <van-icon class="ion" name="cross" @click="show = false" />
      <div class="contents">
        <div class="productInfo">
          <div class="imgge">
            <img :src="img" alt="" />
          </div>
          <div class="productTitle">
            <h4>{{ productInfo.goods_name }}</h4>
            <span class="money"
              >¥{{ price ? price : productInfo.outer_goods_price }}</span
            >
          </div>
        </div>
        <div class="specifications">
          <div>
            <span style="font-weight: 600;">颜色</span>
            <div class="btn">
              <van-button
                v-for="(item, index) in opmInfo"
                :key="index"
                :icon="item.color_img"
                size="small"
                :class="{ formats: isActive === item.id }"
                @click="getBack(item)"
                :disabled="item.stock <= 0 ? true : false"
              >
                {{ item.color_name }}
              </van-button>
            </div>
          </div>
          <div class="num">
            <span style="font-weight: 600;">数量</span>
            <van-stepper
              v-model="value"
              min="1"
              :max="totalQuantity < 99 ? totalQuantity : '99'"
              theme="round"
              button-size="22"
              disable-input
            />
          </div>
        </div>
        <div class="btnBox">
          <van-button round @click="selectInfo" type="info">确定</van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="shows">
      <van-icon class="ion" name="cross" @click="shows = false" />
      <div class="contents">
        <div class="productInfo">
          <div class="imgge">
            <img :src="img" alt="" />
          </div>
          <div class="productTitle">
            <h4>{{ productInfo.goods_name }}</h4>
            <span class="money"
              >¥{{ price ? price : productInfo.outer_goods_price }}</span
            >
          </div>
        </div>
        <div class="specifications">
          <div>
            <span style="font-weight: 600;">颜色</span>
            <div class="btn">
              <van-button
                v-for="(item, index) in opmInfo"
                :key="index"
                :icon="item.color_img"
                size="small"
                :class="{ formats: isActive === item.id }"
                @click="getBack(item)"
                :disabled="item.stock <= 0 ? true : false"
              >
                {{ item.color_name }}
              </van-button>
            </div>
          </div>
          <div class="num">
            <span style="font-weight: 600;">数量</span>
            <van-stepper
              v-model="value"
              min="1"
              :max="totalQuantity < 99 ? totalQuantity : '99'"
              theme="round"
              button-size="22"
              disable-input
            />
          </div>
        </div>
        <div class="btnBox">
          <van-button round @click="selectInfoTwo" type="info">确定</van-button>
        </div>
      </div>
    </van-action-sheet>
    <!-- 地址 -->
    <van-action-sheet v-model="addressListShow" class="addressListShow">
      <div class="content">
        <van-address-list
          v-model="chosenAddressId"
          :list="list"
          default-tag-text="默认地址"
          add-button-text="选择其他地址"
          @click-item="onfirmAddress"
          @add="openAreaList"
        />
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="areaListShow">
      <div class="content">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @change="areaOnChange"
          @close="areaListShow = false"
          @finish="onFinish"
        />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import checkDevice from "../../tools/app";
import "video.js/dist/video-js.css";
export default {
  data() {
    return {
      opmInfo: [],
      areaShow: false,
      areaListShow: false,
      list: [],
      price: "",
      chosenAddressId: "",
      addressListShow: false,
      // 总数量
      totalQuantity: "",
      radio: "",
      flag: true,
      onsell: false,
      show: false,
      shows: false,
      showOne: false,
      AddressShow: false,
      AddressList: {},
      active: 0,
      images: [],
      current: 0,
      productID: "",
      productInfo: {},
      productImg: {},
      commentList: {},
      imgList: {},
      value: "1",
      commentLength: "",
      Evaluation: true,
      imagesLists: [],
      status: "", // '0-下架；1-上架；2-预售'
      ImagePreviewShow: false,
      imgIndex: 0,
      cartNum: "",
      addCartNum: "",
      cart: {},
      img: "",
      addressId: sessionStorage.getItem("_ADDRESS"),
      radioName:
        sessionStorage.getItem("R_N") != ""
          ? sessionStorage.getItem("R_N")
          : "",
      valueNum:
        sessionStorage.getItem("V_N") != ""
          ? sessionStorage.getItem("V_N")
          : "",
      // 地址数据
      province: "",
      city: "",
      county: "",
      street: "",
      fieldValue: "",
      cascaderValue: "",
      detailedAddress: "",
      options: [],
      onsell_num: "",
      isActive: "",
    };
  },
  mounted() {
    this.getProductID();
    this.getComment();
    this.getShoppingCart();
    this.getAddressList();
    this.getProvince();
  },
  methods: {
    select(e, index) {
      this.isActive = index;
      this.radio = e;
    },
    getBack(item) {
      this.img = item.color_img;
      this.totalQuantity = item.stock;
      this.isActive = item.id;
      this.radio = item.color_name;
      this.productImg = item.color_img;
      this.price = item.price;
      this.value = "1";
    },
    // 地址事件
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.areaListShow = false;
      this.province = selectedOptions[0].value;
      this.city = selectedOptions[1].value;
      this.county = selectedOptions[2].value;
      sessionStorage.setItem("_PROVINCE", this.province);
      sessionStorage.setItem("_CITY", this.city);
      sessionStorage.setItem("_COUNTY", this.county);
      if (selectedOptions.length == 4) {
        this.street = selectedOptions[3].value;
        sessionStorage.setItem("_STREET", this.street);
      } else {
        this.street = "";
      }
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.AddressShow = true;
      sessionStorage.setItem("AREA", this.fieldValue);
    },
    // 点击获取市、区、镇级数据
    areaOnChange({ value }) {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
        params: {
          parentId: value,
        },
      }).then((res) => {
        if (res.retCode == 200) {
          if (res.data.code.length == 0) {
            return false;
          } else {
            // 市级数据
            if (res.data.code[0].level == 2) {
              this.options.forEach((element) => {
                element.children = [];
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  if (element.value == item.parent_id) {
                    element.children.push({
                      text: item.name,
                      value: item.id,
                      children: [],
                    });
                  }
                });
              });
              // 区/县级数据
            } else if (res.data.code[0].level == 3) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children = [];
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    if (element2.value == item.parent_id) {
                      if (item.childCount == 0) {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                        });
                      } else {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                          children: [],
                        });
                      }
                    }
                  });
                });
              });
              // 镇/街道级数据
            } else if (res.data.code[0].level == 4) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children.forEach((element3) => {
                    element3.children = [];
                  });
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    element2.children.forEach((element3) => {
                      element3.children.push({
                        text: item.name,
                        value: item.id,
                      });
                    });
                  });
                });
              });
            }
          }
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 获取省级数据
    getProvince() {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
          this.options = [].concat(...this.options);
        } else {
          this.$toast("获取地址信息失败");
        }
      });
      // }
    },
    openAreaList() {
      this.addressListShow = false;
      this.areaListShow = true;
    },
    // 点击切换地址
    onfirmAddress(item) {
      sessionStorage.setItem("_ADDRESS", item.id);
      sessionStorage.setItem("AREA", item.address);
      this.fieldValue = item.address;
      this.addressListShow = false;
    },
    // 获取默认地址信息
    async getAddressList() {
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        return;
      } else {
        if (sessionStorage.getItem("AREA") == null && this.addressId == null) {
          await this.$post({
            url: "/omsConsigneeAddress/findAll",
            method: "post",
            params: {
              userId: sessionStorage.getItem("EXCLUSIVE"),
            },
          }).then((res) => {
            if (res.retCode == 200 && res.data.code.length > 0) {
              this.AddressShow = true;
              res.data.code.map((item) => {
                return this.list.push({
                  id: item.address_id,
                  name: item.consignee,
                  tel: item.mobile.replace(item.mobile.substr(3, 4), "****"),
                  address: item.address_str,
                  isDefault: item.first_choice == 1 ? true : false,
                });
              });
              sessionStorage.setItem("_ADDRESS", res.data.code[0].address_id);
              this.fieldValue = res.data.code[0].address_str;
            } else {
              this.AddressShow = false;
              sessionStorage.removeItem("_ADDRESS");
            }
          });
        } else {
          await this.$post({
            url: "/omsConsigneeAddress/findAll",
            method: "post",
            params: {
              userId: sessionStorage.getItem("EXCLUSIVE"),
            },
          }).then((res) => {
            if (res.retCode == 200) {
              this.AddressShow = true;
              res.data.code.map((item) => {
                return this.list.push({
                  id: item.address_id,
                  name: item.consignee,
                  tel: item.mobile.replace(item.mobile.substr(3, 4), "****"),
                  address: item.address_str,
                  isDefault: item.first_choice == 1 ? true : false,
                });
              });
              if (sessionStorage.getItem("AREA")) {
                this.fieldValue = sessionStorage.getItem("AREA");
              } else {
                this.AddressList = res.data.code.filter((item) => {
                  return this.addressId == item.address_id;
                });
                this.fieldValue = this.AddressList[0].address_str;
              }
            }
          });
        }
      }
    },
    //地址事件结束
    selectInfos() {
      if (this.radio == "") {
        this.$toast("请选择商品规格");
      } else {
        this.radioName = this.radio;
        this.valueNum = this.value;
        sessionStorage.setItem("R_N", this.radioName);
        sessionStorage.setItem("V_N", this.valueNum);
        this.showOne = false;
      }
    },
    // 加入购物车
    selectInfo() {
      if (this.radio == "") {
        this.$toast("请选择商品规格");
      } else {
        this.radioName = this.radio;
        this.valueNum = this.value;
        sessionStorage.setItem("R_N", this.radioName);
        sessionStorage.setItem("V_N", this.valueNum);
        this.show = false;
        this.$post({
          url: "/osc/saveOmsShoppingCart",
          method: "post",
          params: {
            productCode: this.productID,
            goodsNum: this.valueNum,
            userId: sessionStorage.getItem("EXCLUSIVE"),
            skuId: this.isActive,
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              this.$toast.success("已加入购物车");
              this.getShoppingCart();
            } else {
              this.$toast(res.message)
            }
          })
          .catch((err) => {});
      }
    },
    selectInfoTwo() {
      if (this.isActive == "") {
        this.$toast("请选择商品规格");
      } else {
        this.radioName = this.radio;
        this.valueNum = this.value;
        sessionStorage.setItem("R_N", this.radioName);
        sessionStorage.setItem("V_N", this.valueNum);
        this.shows = false;
        this.onClickButton();
        this.$router.push({
          path: "/onfirmOrder",
          query: {
            goodsId: this.productID,
            skuId: this.isActive,
            // name:this.
          },
        });
      }
    },
    touchEvent(scrollTop) {
      if (scrollTop.scrollTop >= 45) {
        document.querySelector(".van-tabs__wrap").style.display = "block";
        if (this.active == 0) {
          document.querySelector(".van-tabs__line").style.transform =
            "translateX(2.42rem) translateX(-50%)";
        }
      } else {
        document.querySelector(".van-tabs__wrap").style.display = "none";
      }
    },
    // 获取产品信息
    async getProductID() {
      this.productID = sessionStorage.getItem("P_ID");
      await this.$post({
        url: "/owsProductInfo/findProductInfoById",
        method: "post",
        params: {
          goodsId: this.productID,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.onsell_num = res.data.code.onsell_num;
            if (this.onsell_num == 0) {
              this.onsell = true;
            }
            this.status = res.data.code.status;
            this.totalQuantity = res.data.code.inv_sync_inv;
            this.images = res.data.imgAndVideoList;
            this.img = res.data.opmInfo[0].color_img;
            this.productInfo = res.data.code;
            sessionStorage.setItem("P_IMG", this.productInfo.productImg);
            this.opmInfo = res.data.opmInfo;
          }
        })
        .catch((err) => {});
    },
    // 获取购物车的数据
    getShoppingCart() {
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        return;
      } else {
        this.$post({
          url: "/osc/findOmsShoppingCartAll",
          method: "post",
          params: {
            userId: sessionStorage.getItem("EXCLUSIVE"),
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              this.cart = res.data.code;
              this.cartNum = res.data.code.length;
            }
          })
          .catch((err) => {
            // this.$toast("加载失败");
          });
      }
    },
    // 获取评论
    async getComment() {
      await this.$post({
        url: "ogc/getByGoodssn",
        method: "get",
        params: {
          goods_sn: sessionStorage.getItem("P_ID"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.commentList = res.data.slice(0, 4);
            this.commentLength = res.data.length;
            if (this.commentLength <= 0) {
              this.Evaluation = false;
              this.commentLength = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 切换轮播图的图片数量位置
    onChange(index) {
      this.current = index;
    },
    // 点击客服
    onClickIcon() {
      this.$toast("正在开发中");
    },
    // 点击加入购物车
    async addShoppingCart() {
      let phone = checkDevice();
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        if (phone == "android") {
          window.jsCallAndroid.jsCallUnLoginFunction(); //调用安卓的api跳转到未登录页面
        } else if (phone == "ios") {
          window.webkit.messageHandlers.UnLogin.postMessage(""); //调用ios的api
        }
        return;
      } else {
        this.show = true;
      }
    },
    // 点击立即购买 储存当前产品信息
    onClickButton() {
      let phone = checkDevice();
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        if (phone == "android") {
          window.jsCallAndroid.jsCallUnLoginFunction(); //调用安卓的api跳转到未登录页面
        } else if (phone == "ios") {
          window.webkit.messageHandlers.UnLogin.postMessage(""); //调用ios的api
        }
        return;
      } else {
      this.shows = true;
      sessionStorage.setItem("PRODUCT_CODE", this.productInfo.id);
      sessionStorage.setItem("PRODUCT_NUM", this.valueNum);
      let productList = [
        {
          color_name: this.radioName,
          recordId: this.productInfo.goods_id,
          goods_num: sessionStorage.getItem("PRODUCT_NUM"),
          price: this.price,
          product_name: this.productInfo.goods_name,
          color_img: this.productImg,
          onsellNum: this.onsell_num,
        },
      ];
      // 地址信息
      sessionStorage.setItem("AREA", this.fieldValue);
      sessionStorage.setItem("PRODUCT_LIST", JSON.stringify(productList));
      }
    },
    // 进入购物车
    toBuyCart() {
      let phone = checkDevice();
      if (
        sessionStorage.getItem("EXCLUSIVE") == "" ||
        sessionStorage.getItem("EXCLUSIVE") == null
      ) {
        if (phone == "android") {
          window.jsCallAndroid.jsCallUnLoginFunction(); //调用安卓的api跳转到未登录页面
        } else if (phone == "ios") {
          window.webkit.messageHandlers.UnLogin.postMessage(""); //调用ios的api
        }
      } else {
        this.$router.push("/buyCart");
        if (this.$route.path == "/buyCart") {
          this.$router.go(0);
        }
      }
    },
    // 返回
    toback() {
      sessionStorage.removeItem("R_N");
      sessionStorage.removeItem("V_N");
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.contentss {
  width: 100%;
  background-color: #f6f6f6;
  overflow: hidden;
  .shoppingOptions {
    .iconImg {
      width: 0.586667rem;
      height: 0.586667rem;
    }
    /deep/.van-badge--fixed {
      top: 0.053333rem;
      right: 0.32rem;
    }
  }
  .addressListShow {
    height: 100% !important;
    background-color: #fafafa;
    .van-action-sheet__content {
      margin-top: 1rem;
      /deep/.van-icon.van-icon-success {
        display: none;
      }
      /deep/.van-icon.van-icon-edit.van-address-item__edit {
        display: none;
      }
    }
  }
  .contents {
    // height: 9.83rem;
    .productInfo {
      display: flex;
      margin: 0;
      padding: 0;
      .imgge {
        margin: 0.6133rem 0 0 0.9067rem;
        img {
          width: 2.1333rem;
          height: 2.1333rem;
          object-fit: cover;
        }
      }
      .productTitle {
        vertical-align: middle;
        margin-top: 0.9133rem;
        padding-left: 0.64rem;
        margin-bottom: 0.8rem;
        h4 {
          width: 5.5rem;
          font-weight: 500;
          margin-bottom: 0.48rem;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .money {
          display: block;
          color: #f74b2e;
          font-size: 0.5333rem;
        }
      }
    }
    .specifications {
      overflow: hidden;
      margin-left: 0.91rem;
      .btn {
        display: flex;
        flex-wrap: wrap;
        .van-button {
          margin-right: 0.8rem;
          margin-top: 0.4rem;
          border: 0;
          border-radius: 0.08rem;
          background-color: #f7f7f8;
        }
        .formats {
          background: #ffeae6;
          color: #fc563a;
          border-radius: 0.08rem;
        }
      }
      .checkedColor {
        background-color: #f74b2e;
        border-color: #f74b2e;
        color: #ffffff;
      }
      .models {
        display: flex;
        align-items: center;
        .format {
          font-size: 0.3733rem;
          padding: 0.08rem 0.2133rem;
          border: 1px solid #707070;
          border-radius: 0.3467rem;
          margin-left: 0.4rem;
          color: #333333;
        }
        .formats {
          background-color: #f74b2e;
          color: #ffffff;
          border: 0.0267rem solid #f74b2e;
        }
        .Version {
          display: flex;
          .versionFoot {
            border: 1px solid #707070;
            padding: 0.2667rem;
            border-radius: 13px;
          }
        }
      }
      .num {
        margin-top: 0.77rem;
        span {
          float: left;
        }
        .van-stepper {
          float: right;
          margin-right: 0.4rem;
        }
      }
    }
    .btnBox {
      text-align: center;
      margin-top: 0.85rem;
      .van-button {
        width: 8rem;
        height: 1.33rem;
        line-height: 1.33rem;
        background-color: #fc563a;
        border-color: #fc563a;
        font-size: #fff;
      }
    }
  }
  .sell {
    width: 10rem;
    line-height: 1.173333rem;
    text-align: center;
    height: 1.173333rem;
    background-color: #dedede;
    position: fixed;
    left: 0;
    bottom: 1.306667rem;
  }
  .sold {
    width: 3.2rem;
    text-align: center;
    line-height: 0.96rem;
    height: 0.96rem;
    background-color: #c1c1c1;
    border-radius: 0.48rem;
    color: #666666;
    font-size: 0.373333rem;
    font-family: PingFang SC;
    font-weight: 400;
    margin-left: 4rem;
  }
  .headerIcon {
    position: absolute;
    top: 0.3125rem;
    left: 0;
    width: 100%;
    z-index: 99;
    .share,
    .back {
      display: inline-block;
      width: 0.746667rem;
      height: 0.746667rem;
      margin-left: 0.3125rem;
    }
    .share {
      display: block;
      float: right;
      margin-right: 0.3125rem;
    }
  }
  .van-tabs {
    /deep/.van-tabs__wrap {
      display: none;
    }
    width: 100%;
    /deep/.van-tab--disabled {
      color: #646566 !important;
    }
    .van-icon {
      margin-top: 0.3rem;
      padding-left: 0.4rem;
      font-size: 0.5rem;
    }
    .van-tab {
      .van-tabs__line {
        padding-left: 1rem;
      }
    }
    .bigImg {
      width: 100%;
      height: 100%;
      padding-bottom: 1.2rem;
      img {
        width: 100%;
      }
    }
  }
  .swiper {
    box-sizing: border-box;
    .van-swipe {
      position: relative;
      img {
        width: 100%;
        // height: 9rem;
        height: auto;
        display: block;
      }
      .custom-indicator {
        position: absolute;
        right: 0.266667rem;
        bottom: 0.266667rem;
        padding: 0.053333rem 0.133333rem;
        color: #fff;
        font-size: 0.32rem;
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .productInfo {
    overflow: hidden;
    padding-top: 0.27rem;
    padding-left: 0.37rem;
    background-color: #fff;
    h4 {
      margin-top: 0.1rem;
      font-size: 0.45rem;
    }
    p {
      font-size: 0.53;
      line-height: 1rem;
    }
    .bewrite {
      margin-top: 0.1rem;
      display: inline-block;
      color: #cccccc;
      font-size: 0.32rem;
      width: 9rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .money {
      font-size: 0.53rem;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 0.75rem;
      color: #f74b2e;
    }
  }
  .site {
    ul {
      margin-top: 0.2rem;
      background-color: #fff;
      li {
        height: 1.226667rem;
        display: flex;
        align-items: center;
        margin: 0 0.37rem;
        border-bottom: 0.026667rem solid #eeeeee;
        position: relative;
        .text {
          font-weight: 600;
          font-size: 0.373333rem;
          color: #333333;
          font-family: PingFang SC;
        }
        .siteTwo {
          margin-left: 0.48rem;
          font-size: 0.373333rem;
          font-weight: 400;
          color: #333333;
          font-family: PingFang SC;
        }
        .selectAddress {
          margin-left: 0.48rem;
          font-size: 0.373333rem;
          font-weight: 400;
          color: #333333;
          font-family: PingFang SC;
          span {
            display: block;
            width: 6rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .lastOptions {
          display: flex;
          align-items: center;
          div {
            display: flex;
            align-items: center;
            margin-left: 0.266667rem;
            img {
              display: block;
              width: 0.32rem;
              height: 0.32rem;
            }
            span {
              margin-left: 0.106667rem;
              font-size: 0.32rem;
              font-weight: 400;
              color: #333333;
              font-family: PingFang SC;
            }
          }
        }
        .arrow {
          font-size: 0.48rem;
          position: absolute;
          color: #666666;
          right: 0;
          bottom: 0.346667rem;
        }
      }
    }
  }
  .appraisal {
    margin-top: 0.27rem;
    background-color: #fff;
    padding: 0.35rem 0.37rem 0 0.35rem;
    .appraisalHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem 0 0.3rem 0;
      p {
        font-size: 0.373333rem;
        font-weight: 600;
        color: #333333;
        font-family: PingFang SC;
      }
      div {
        display: flex;
        align-items: center;
        font-size: 0.32rem;
        font-weight: 400;
        color: #333333;
        font-family: PingFang SC;
        /deep/.van-icon-arrow {
          padding: 0;
          margin: 0;
        }
      }
    }
    // 评价按钮
    .appraisalFilter {
      padding-bottom: 0.4rem;
      border-bottom: 0.026667rem solid #eeeeee;
      .van-button {
        margin: 0.1125rem 0;
        margin-right: 0.32rem;
        border-radius: 0.4rem;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        color: #333333;
        border-color: #e0e0e0;
        background-color: #e0e0e0;
      }
    }
  }
  .noEvaluation {
    height: 3rem;
    line-height: 1.5rem;
    background-color: #fff;
    p {
      text-align: center;
    }
  }
  .appraisalList {
    background-color: #fff;
    margin-bottom: 0.5rem;
    ul {
      li {
        margin: 0 0.4rem 0 0.426667rem;
        border-bottom: 0.026667rem solid #eeeeee;
        .head {
          // margin-top: 0.213333rem;
          padding-top: 0.213333rem;
          display: flex;
          img {
            width: 0.906667rem;
            height: 0.906667rem;
            border-radius: 50%;
            border: 0.026667rem solid #ededed;
          }
          .headTop {
            margin-left: 0.373333rem;
            .name {
              font-size: 0.373333rem;
              font-weight: 400;
              color: #333333;
              font-family: PingFang SC;
            }
            .headeValuate {
              display: flex;
              align-items: center;
              p {
                margin-top: 0.08rem;
                width: 2rem;
                height: 0.373333rem;
                overflow: hidden;
                font-size: 0.32rem;
                font-weight: 400;
                color: #666666;
              }
            }
          }
        }
        .evaluateConent {
          margin: 0.45rem 0;
          font-size: 0.32rem;
          font-weight: 400;
          color: #333333;
        }
        .cpnentImg {
          display: flex;
          flex-wrap: wrap;
          justify-content: last baseline;
          img {
            width: 2.133333rem;
            height: 2.133333rem;
            margin: 0 0.16rem 0.213333rem 0;
            border-radius: 0.053333rem;
          }
        }
      }
    }
  }
  .ion {
    float: right;
    font-size: 0.6133rem;
    padding: 6px;
    color: #666;
    margin-right: 5px;
  }
  /deep/.van-popup--bottom.van-popup--round {
    border-radius: 0.1333rem 0.1333rem 0 0;
  }
}
</style>
